import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { IdToken } from '@auth0/auth0-angular';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { take, tap } from 'rxjs';
import { filter } from 'rxjs/operators';

import {
  Auth0Service,
  AuraAuthService,
  SessionData,
} from '@digital-platform/aura-authentication/services';
import { SpinnerService } from '@digital-platform/rs-shared/services';
import { SafeHtmlPipe } from '@digital-platform/rs-shared/ui';
import { APP_SWITCHER_ROUTE } from '@digital-platform/rs-signup/domain';

@UntilDestroy()
@Component({
  selector: 'digital-platform-cor-success',
  standalone: true,
  imports: [CommonModule, TranslateModule, SafeHtmlPipe],
  providers: [TranslatePipe],
  templateUrl: './cor-success.component.html',
  styleUrls: ['./cor-success.component.scss'],
})
export class CorSuccessComponent implements OnInit {
  public user!: IdToken;
  public portalName: string | undefined = '';
  private auth0Service = inject(Auth0Service);
  private spinner = inject(SpinnerService);
  private router = inject(Router);
  private auraAuthService = inject(AuraAuthService);

  constructor() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        const navigation = this.router.getCurrentNavigation();
        if (navigation?.extras.state) {
          this.portalName = navigation.extras.state['portal'];
        }
      });
  }

  ngOnInit(): void {
    this.fetchUserData();
  }

  private fetchUserData(): void {
    this.spinner.startLoading('');
    this.auraAuthService
      .getAllSessionData()
      .pipe(
        take(1), // automatically unsubscribes after the first value is emitted
        untilDestroyed(this)
      )
      .subscribe({
        next: (sessionData: SessionData | null) => {
          this.user = sessionData?.idTokenClaims as IdToken;
          this.spinner.stopLoading('');
        },
        error: (err) => {
          console.error('Error fetching user data:', err);
          this.spinner.stopLoading('');
        },
      });
  }

  goToAppSwitcher(): void {
    this.router.navigate([APP_SWITCHER_ROUTE]);
  }
}
